// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireStepFragmentDoc } from './QuestionnaireStep.fragment.generated';
import { LinkItemFragmentDoc } from '../../../../graphql/api/cms/link.fragment.generated';
import { QuestionnaireSignUpStepFragmentDoc } from './QuestionnaireSignUpStep.fragment.generated';
export const QuestionnaireFragmentDoc = gql`
    fragment questionnaire on Questionnaire {
  __typename
  id
  title
  type
  steps {
    ...questionnaireStep
  }
  signUpStep {
    ...questionnaireSignUpStep
  }
  redirectLink {
    ...linkItem
  }
}
    ${QuestionnaireStepFragmentDoc}
${QuestionnaireSignUpStepFragmentDoc}
${LinkItemFragmentDoc}`;